import { EmailInput } from '../baseInputs'

type Props = {
  helper?: string
}

const EmailConfirm = ({ helper, ...rest }: Props) => {
  const name = 'confirm_email'
  const label = 'Confirm email'

  return <EmailInput name={name} label={label} helper={helper} {...rest} />
}

export default EmailConfirm
